import * as home from './home';
import * as product from './product';
import * as media from './media';
import * as brand from './brand';
import * as about from './about';
import * as qr from './qr';
import * as news from './news';
import * as mediaVideo from './mediaVideo';
import * as dict from './dict';
import * as friends from './friends';
import * as video from './video';

export default {
  home,
  product,
  media,
  brand,
  about,
  qr,
  news,
  mediaVideo,
  dict,
  friends,
  video
}; 